import FormattedMessage from 'I18n/components/FormattedMessage';
import { useSelector } from 'react-redux';
import { currentOrderedPaidProductLevels } from 'self-service-api/constants/ProductLevels';
import SplashPageCard from '../SplashPageCard';
import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import { PageSection, SectionContainer, SectionHeader, SectionSubTitle, SectionTitle } from 'pricing-pages-ui-components/semantic/PageSection';
import { STARTER, tabIdToProductLevels } from 'pricing-pages-ui/constants/routing/Tabs';
import { SPLASH_PAGE_CARD } from '../../../constants/tracking/TrackingSources';
import { useMedia } from '../../../hooks/useMedia';
import { isAppAuthSelector } from '../../../selectors/AuthSelectors';
import { isUngatedForMarketingPlusSelector } from '../../../selectors/GatingSelectors';
import { useSSM0009Experiment } from '../../../utils/experiments/ssm0009';
import StarterCrmSuiteCard from './StarterCrmSuiteCard';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CardGridWrapper = props => {
  const isMaxWidthTablet = useMedia('tablet');
  return /*#__PURE__*/_jsx(CardGrid, {
    columnSize: isMaxWidthTablet ? 295 : 200,
    gap: "800",
    children: props.children
  });
};
const SuiteSection = ({
  selectedTab,
  sectionProps
}) => {
  const {
    isSSM0009Variant
  } = useSSM0009Experiment();
  const isAppAuth = useSelector(isAppAuthSelector);
  const isUngatedForMarketingPlus = useSelector(isUngatedForMarketingPlusSelector);
  const productLevelTiles = currentOrderedPaidProductLevels.map(productLevel => {
    const suiteTabFromProductLevel = Object.keys(tabIdToProductLevels).find(tabId => tabIdToProductLevels[tabId].includes(productLevel));
    const trackingSource = `${productLevel.toLowerCase()}-${SPLASH_PAGE_CARD}`;
    return /*#__PURE__*/_jsx(SplashPageCard, {
      titleKey: `splash-page.bundles.${productLevel}.title`,
      descriptionKey: `splash-page.bundles.${productLevel}.description`,
      showIcon: false,
      pathname: isAppAuth || isSSM0009Variant ? '/suite' : `/suite/${suiteTabFromProductLevel}`,
      trackingSource: trackingSource
    }, productLevel);
  });
  return /*#__PURE__*/_jsx(PageSection, Object.assign({}, sectionProps, {
    children: /*#__PURE__*/_jsxs(SectionContainer, {
      paddingBlockStart: (sectionProps === null || sectionProps === void 0 ? void 0 : sectionProps.use) === 'shaded' ? '800' : undefined,
      paddingBlockEnd: (sectionProps === null || sectionProps === void 0 ? void 0 : sectionProps.use) === 'shaded' ? '1300' : undefined,
      children: [/*#__PURE__*/_jsxs(SectionHeader, {
        children: [/*#__PURE__*/_jsx(SectionTitle, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `splash-page.bundles.title.${selectedTab}`
          })
        }), /*#__PURE__*/_jsx(SectionSubTitle, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `splash-page.bundles.subtitle.${selectedTab}`
          })
        })]
      }), selectedTab === STARTER ? /*#__PURE__*/_jsx(StarterCrmSuiteCard, {}) : /*#__PURE__*/_jsxs(CardGridWrapper, {
        children: [productLevelTiles, isUngatedForMarketingPlus && /*#__PURE__*/_jsx(SplashPageCard, {
          titleKey: "splash-page.bundles.marketingPlus.title",
          descriptionKey: "splash-page.bundles.marketingPlus.description",
          showIcon: false,
          pathname: "/marketing-plus",
          trackingSource: `marketing-plus-${SPLASH_PAGE_CARD}`
        })]
      })]
    })
  }));
};
export default SuiteSection;